import { apiInstance, handleApiError } from "./InstanceApi";

export const searchLinkReference = async ({
  page = 1,
  limit = 10,
  name = "",
}) => {
  try {
    const response = await apiInstance.get("/linkreference-data/search", {
      params: {
        page: page,
        limit: limit,
        name: name,
      },
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const createLinkReference = async (data) => {
  try {
    const response = await apiInstance.post("/linkreference-data", data);
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateLinkReference = async ({ id, data }) => {
  try {
    const response = await apiInstance.put(`/linkreference-data/${id}`, data);
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteLinkReferenceById = async (id) => {
  try {
    const response = await apiInstance.delete(`/linkreference-data/${id}`);
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const importLinkReference = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const response = await apiInstance.post(
      "/linkreference-data/import",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};
